module.exports = __webpack_public_path__ + "img/flecha-der.0496310b.png";